import { render, staticRenderFns } from "./IndustryWorkshop.vue?vue&type=template&id=46d7324b&scoped=true&"
import script from "./IndustryWorkshop.vue?vue&type=script&lang=js&"
export * from "./IndustryWorkshop.vue?vue&type=script&lang=js&"
import style0 from "./IndustryWorkshop.vue?vue&type=style&index=0&id=46d7324b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d7324b",
  null
  
)

export default component.exports